import Vue from "vue"
import VueI18n from "vue-i18n"

import ar from "../src/assets/locales/ar.json"
import bu from "../src/assets/locales/bu.json"
import en from "../src/assets/locales/en.json"
import fr from "../src/assets/locales/fr.json"
import pt from "../src/assets/locales/pt.json"

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en",
  fallbackLocale: "en",
  messages: {
    ar: ar,
    bu: bu,
    en: en,
    fr: fr,
    pt: pt,
  },
})

export default i18n
